import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { A } from 'styles/Styles.styled';

const Footer: React.FunctionComponent = () => {
  const { t } = useTranslation();
  return (
    <MainFooter>
      {t('footer.text')}
      <span style={{ marginLeft: '0.5rem', marginRight: '0.5rem' }}>{'|'}</span>
      <A href={t('footer.link')} target="_blank" rel="noopener noreferrer">
        {t('footer.linkText')}
      </A>
    </MainFooter>
  );
};

const MainFooter = styled.footer`
  width: 100%;
  height: 70px;
  margin-top: auto;
  background-color: #e8f1e9;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  font-family: Inter;
  color: ${(props) => props.theme.colors.primaryBlack};
  font-size: 14px;

  @media print {
    display: none;
  }
`;

export default Footer;
